import styled from 'styled-components';
import { Select } from 'antd';

const LangSelect = styled(Select)`
	position: absolute;
	top: 20px;
	right: 40px;
	width: 90px;
`;

export default LangSelect;
